import { createContext } from 'react';

import { SalesOrderLine } from '@totem/components/salesOrders/list/types';

interface Context {
  loading: boolean;
  lines: SalesOrderLine[];
  totalRecords: number;
  refetch: () => void;
}

const defaultContext: Context = {
  loading: false,
  lines: [],
  totalRecords: 0,
  refetch: () => {},
};

const SalesOrdersContext = createContext<Context>(defaultContext);

export default SalesOrdersContext;
